let _injected_version;
try {
  _injected_version = VERSION_INJECTED_BY_WEBPACK;
} catch (error) {
  console.debug("VERSION not injected");
}

export const METADATA_PRODUCER_NAME = "QwilSign Template Editor";
export const METADATA_PRODUCER_VERSION = _injected_version;
export const METADATA_PRODUCER_NAME_FULL = `${METADATA_PRODUCER_NAME} (${METADATA_PRODUCER_VERSION})`;

export const PLACEHOLDER_MIN_DELAY = 1000;

export const OUTPUT_FILENAME_PREFIX = "QwilSignTemplate_";

export const CSSClass = {
  DRAGGABLE_ANCHOR: "movable-anchor",
  STATIC_ANCHOR: "static-anchor",
  FLOATING_ANCHOR: "floating-anchor",
  PREVIEW_ANCHOR: "preview-anchor",
  MOVABLE_ANCHOR: "movable-anchor",
  RESIZABLE_MOVABLE_ANCHOR: "resizable-movable-anchor",
  // ANCHOR_IN_PAGE: "anchor-in-page",
  PAGE: "page",
  THUMBNAIL: "thumbnail",
  PAGE_CANVAS: "page-canvas",
  DROP_TARGET_CANDIDATES: "drop-target-candidate",
  DROP_TARGET_ACTIVE: "drop-target-active",
};

export const ElemID = {
  // Here we mainly store component ids, and element ids that need to be referenced
  // in more than one place.
  DOCUMENT: "full-page",
  PREVIEW_PREFIX: "preview-",
  ANCHOR_PREFIX: "anchor-",
  PAGE_PREFIX: "page-",
  THUMBNAIL_PREFIX: "thumbnail-",
  THUMBNAIL_TAB_PREFIX: "thumbnail-tab-",
  CANVAS_PREFIX: "page-canvas-",
  CANCEL_BUTTON: "cancel-button",
  PREVIEW_BUTTON: "preview-button",
  BACK_BUTTON: "back-button",
  EXPORT_BUTTON: "export-button",
  FORCE_CANCEL_BUTTON: "force-cancel-button",
  HEADER_BUTTON_CONTAINER: "header-button-container",
  CANCEL_CONFIRMATION_MODAL: "cancel-confirmation-modal",

  EDITOR_COMPONENT: "editor-component",
  PREVIEW_COMPONENT: "preview-component",
  PREVIEW_PAGE_CONTAINER: "preview-page-container",
  PREVIEW_PAGE_CONTAINER_WRAPPER: "preview-page-container-wrapper",
  PREVIEW_THUMBNAIL_CONTAINER: "preview-thumbnail-sidebar-panel",
  EDITOR_PAGE_CONTAINER: "editor-page-container",
  EDITOR_PAGE_CONTAINER_WRAPPER: "editor-page-container-wrapper",
  EDITOR_THUMBNAIL_CONTAINER: "thumbnail-sidebar-panel",
  PLACEHOLDER_COMPONENT: "placeholder-component",
  UPLOADER_COMPONENT: "uploader-component",
  DOWNLOADER_COMPONENT: "downloader-component",
  PDF_REJECTED_COMPONENT: "pdf-rejected-component",
};
